import { Badge, Box, Button, Stack, Typography } from "@mui/material";
import * as React from "react";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import {
  CloseDrawerIcon,
  NotificationIcon,
} from "../../../components/ui-elements/svg-icons";
import { styled, useTheme } from "@mui/material/styles";
import { NotificationMessage } from "../../../interface/messages";

export const NotificationDetails = ({
  data,
  anchorEl,
  open,
  handle_close,
}: {
  data: NotificationMessage[];
  open: boolean;
  handle_close: () => void;
  anchorEl: null | HTMLElement;
}) => {
  const theme = useTheme();

  // const echo = useEcho();
  const id = useSelector(
    (state: RootState) => state.content.account_profile_data
  ).id;

  return (
    <>
      <Menu
        disablePortal
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handle_close}  // This will handle clicking outside
        onClick={(e) => e.stopPropagation()} 
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&::before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 20,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem sx={{}}>
          <Stack
            direction={"row"}
            width={450}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Typography
              variant="subtitle2"
              sx={{ color: "#9C9AA5", fontWeight: 400 }}
            >
              Notification
            </Typography>
            <Button onClick={handle_close}>
              <CloseDrawerIcon />
            </Button>
          </Stack>
        </MenuItem>
        <Box
          sx={{
            overflowY: "auto",
            
            height: 250,
            padding: 1,
          }}
        >
          {data.map((notification: NotificationMessage) => (
            <MenuItem sx={{}} key={notification.id}>
              <Stack direction="column" spacing={1}>
                <Box sx={{ marginLeft: 1, width: 450, overflowX: 'auto' }}>
                  <Typography variant="subtitle2" color="black">
                    {notification.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="gray"
                    sx={{ }}
                  >
                    {notification.body}
                  </Typography>
                </Box>
              </Stack>
            </MenuItem>
          ))}
          {data?.length === 0 && (
            <Typography variant="body2" color="black" sx={{ fontWeight: 500 }}>
              You don't have any notifications
            </Typography>
          )}
        </Box>
      </Menu>
    </>
  );
};
